module.exports = __webpack_public_path__ + "img/The_US_still_has_780_billion_worth_of_physical_stock_certificates.ac197334.jpg";